(function () {
  'use strict';

  function initVerticalThumbs(root) {
    const scope = root || document;
    const galleries = scope.querySelectorAll('media-gallery');

    galleries.forEach((gallery) => {
      const thumbList = gallery.querySelector('.thumbnail-list');
      if (!thumbList || thumbList.dataset.rowyakInit) return;
      thumbList.dataset.rowyakInit = '1';

      const thumbWrap = thumbList.closest('slider-component') || thumbList.parentElement;
      if (!thumbWrap) return;

      const upBtn = document.createElement('button');
      upBtn.type = 'button';
      upBtn.className = 'rowyak-thumb-nav rowyak-thumb-nav--up';
      upBtn.setAttribute('aria-label', 'Scroll thumbnails up');
      upBtn.innerHTML =
        '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M3 10l5-5 5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const downBtn = document.createElement('button');
      downBtn.type = 'button';
      downBtn.className = 'rowyak-thumb-nav rowyak-thumb-nav--down';
      downBtn.setAttribute('aria-label', 'Scroll thumbnails down');
      downBtn.innerHTML =
        '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M3 6l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      thumbWrap.insertBefore(upBtn, thumbList);
      thumbWrap.appendChild(downBtn);

      const scrollAmount = () => Math.max(thumbList.clientHeight * 0.8, 100);

      upBtn.addEventListener('click', (e) => {
        e.preventDefault();
        thumbList.scrollBy({ top: -scrollAmount(), behavior: 'smooth' });
      });
      downBtn.addEventListener('click', (e) => {
        e.preventDefault();
        thumbList.scrollBy({ top: scrollAmount(), behavior: 'smooth' });
      });

      function updateButtons() {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const scrollable = thumbList.scrollHeight - thumbList.clientHeight > 1;

        if (!isDesktop || !scrollable) {
          upBtn.classList.add('rowyak-thumb-nav--hidden');
          downBtn.classList.add('rowyak-thumb-nav--hidden');
          return;
        }

        upBtn.classList.remove('rowyak-thumb-nav--hidden');
        downBtn.classList.remove('rowyak-thumb-nav--hidden');

        const atTop = thumbList.scrollTop <= 1;
        const atBottom =
          thumbList.scrollTop >= thumbList.scrollHeight - thumbList.clientHeight - 1;

        upBtn.disabled = atTop;
        downBtn.disabled = atBottom;
      }

      thumbList.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      // Run after layout settles
      requestAnimationFrame(updateButtons);
      setTimeout(updateButtons, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVerticalThumbs());
  } else {
    initVerticalThumbs();
  }

  // Re-init when sections reload (theme editor)
  document.addEventListener('shopify:section:load', (e) => initVerticalThumbs(e.target));
})();
